// extracted by mini-css-extract-plugin
module.exports = {"chevron":"styles__chevron___2BADf","up":"styles__up___3ZhaK","down":"styles__down___3XVON","left":"styles__left___Dj1U_","right":"styles__right___iZ_Su"};